const EventBus = window.EventBus;
export const LineUp = {
    props: ['pathurl', 'vehicles', 'data', 'lang', 'ordered', 'selectedcat','mode'],
    data() {
        return {
            json: null,
            allCategories: null,
            pathUrl: this.pathurl,
            inventory: [],
            lineOrdered: this.ordered,
            seleCategory: this.selectedcat,
            lineMode: this.mode,
            loadingInventory: false,
            filteringOptions: {
              filter: true,
              flags: "none",
              layout: "normal",
              limit: "0",
              make: "all",
              mileage: "all",
              model: "all",
              price: "all",
              sort_by: "year",
              sort_by_condition: "desc",
              status: "all",
              stock: "all",
              tags: "all",
              trim: "all",
              type: "all",
              year: "all",
              component: "lineup",
              location: "all",
            }
        }
    },
    created: function () {
        this.loadingInventory = true;
        this.httpRequestInventory();
    },
    methods: {
        httpRequestInventory() {
            this.loadingInventory = true;
            EventBus.httpRequestInventory(null, this.entryPoint, this.filteringOptions);
        },
        processData() {
            var _this = this;
            _this.json = this.data[1];
            if (this.ordered) {
                _this.greetOrdered();
            }
            else {
                _this.greet();
            }
        },
        entryPoint(inventory) {
            this.loadingInventory = false;
            this.inventory = inventory;
            this.processData();
        },
        greet: function () {
            var carray = [];
            this.seleCategory = [];
            this.allCategories = [];
            this.json.forEach((carrito) => {
                if (!carray.includes(carrito.type.toLowerCase())) {
                    carray.push(carrito.type.toLowerCase());
                }
            });
            if (carray.length != 0) {
                this.seleCategory = this.selectedcat || carray.sort()[0].toLowerCase() || null;
                this.allCategories = carray.sort();
            }
        },
        greetOrdered: function () {
            var carray = [];
            this.seleCategory = [];
            this.allCategories = [];

            this.json.forEach((carrito) => {
                if (!carray.includes(carrito.type.toLowerCase())) {
                    carray.push(carrito.type.toLowerCase());
                }
            });

            this.json.forEach((model) => {
                model.total = this.getTotal(model);
            });

            this.json = this.sortByKey(this.json, 'total', 'desc');

            if (carray.length != 0) {
                this.seleCategory = carray.sort()[0].toLowerCase() || null;
                this.allCategories = carray.sort();
            }
        },
        sortByKey: function (array, key, order) {
            return array.sort(function (a, b) {
                var x = a[key]; var y = b[key];
                if (order == 'desc')
                    return ((x > y) ? -1 : ((x < y) ? 1 : 0));
                else
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        },
        getPrice: function (model) {
            var price = 0;
            var priceText;
            Object.values(this.inventory).forEach((vehicle) => {
                 
                if (((vehicle.price > 0 &&  vehicle.price < price) || price == 0)) {
                    var patt = new RegExp(model.regex);
                    if ((vehicle.condition.toLowerCase() == 'new')){
                        if(model && model.field){
                            if(vehicle[model.field]){
                                var res = patt.test(vehicle[model.field].toLowerCase().split(' ').join('').split('-').join(''));
                                if (res)
                                price = vehicle.price;
                            }
                        }
                        else {
                            if (vehicle.model)                        
                            /*if ((vehicle.model.toLowerCase().indexOf(model.toLowerCase()) !== -1)
                                || (vehicle.model.toLowerCase().split(' ').join('').indexOf(model.toLowerCase().split(' ').join('')) !== -1)
                                || (vehicle.model.toLowerCase().split('-').join('').indexOf(model.toLowerCase().split('-').join('')) !== -1)
                            )*/
                            var res = patt.test(vehicle.model.toLowerCase().split(' ').join('').split('-').join(''));
                            if (res)
                            price = vehicle.price;
                        }
                    }
                        
                               
                }
            })

            priceText = ' - ';
            if (price == 0) {
                price = model.startingat;
            }
            var formatter = new Intl.NumberFormat(this.lang, {
                style: 'currency',
                currency: 'CAD',
                minimumFractionDigits: 0,
            });
            priceText = formatter.format(price);

            return priceText;
        },
        getTotal: function (model) {
            var total = 0;
            Object.values(this.inventory).forEach((vehicle) => {
                if ((vehicle.condition.toLowerCase() == 'new')){
                    var patt = new RegExp(model.regex);
                if(this.data[0].includes("/rv/")){
                    var resrv = patt.test(vehicle.type.toLowerCase().split(' ').join('').split('-').join(''));
                    if (resrv)
                        total++;
                }else{
                    if(model && model.field){
                        if(vehicle[model.field]){
                            var res = patt.test(vehicle[model.field].toLowerCase().split(' ').join('').split('-').join(''));
                        if (res)
                            total++;
                        }
                    }
                    else {
                    if (vehicle.model){
                       // console.log(vehicle.model.toLowerCase().split(' ').join('').split('-').join(''));
                        var res = patt.test(vehicle.model.toLowerCase().split(' ').join('').split('-').join(''));
                        if (res)
                            total++;
                    }
                }
                }
            }
            })
            return total;
        },
        getTotalUsed: function (model) {
            var totalU = 0;
            Object.values(this.inventory).forEach((vehicle) => {
                if ((vehicle.condition.toLowerCase() == 'used' && vehicle.make.toLowerCase() == 'ford')){
                   //console.log("Used");
                    var patt = new RegExp(model.regex);
                if(this.data[0].includes("/rv/")){
                    var resrv = patt.test(vehicle.type.toLowerCase().split(' ').join('').split('-').join(''));
                    if (resrv)
                        totalU++;
                }else{
                    if(model && model.field){
                        if(vehicle[model.field]){
                            //console.log(vehicle[model.field].toLowerCase().split(' ').join('').split('-').join('')+" "+patt);
                            var res = patt.test(vehicle[model.field].toLowerCase().split(' ').join('').split('-').join(''));
                            //console.log(res);
                        if (res)
                            totalU++;
                        }
                    }
                    else {
                    if (vehicle.model){
                       //console.log(vehicle.model.toLowerCase().split(' ').join('').split('-').join(''));
                        var res = patt.test(vehicle.model.toLowerCase().split(' ').join('').split('-').join(''));
                        if (res)
                            totalU++;
                    }
                }
                }
            }
            })
            //console.log(totalU);
            return totalU;
        },
        getRVTotal: function (model) {
            var total = 0;

            this.inventory.forEach((vehicle) => {
                if (vehicle && vehicle.type)
                
                    if ((vehicle.type.toLowerCase().indexOf(model.toLowerCase()) !== -1)
                        || (vehicle.type.toLowerCase().split(' ').join('').indexOf(model.toLowerCase().split(' ').join('')) !== -1)
                        || (vehicle.type.toLowerCase().split('-').join('').indexOf(model.toLowerCase().split('-').join('')) !== -1)
                    )
                        total++;

                if ((model.toLowerCase().indexOf(",") !== -1)) {
                    var types = model.toLowerCase().split(",");
                    types.forEach((cType) => {
                        if ((vehicle.subtype.toLowerCase().indexOf(cType.toLowerCase()) !== -1)
                            || (vehicle.subtype.toLowerCase().split(' ').join('').indexOf(cType.toLowerCase().split(' ').join('')) !== -1)
                            || (vehicle.subtype.toLowerCase().split('-').join('').indexOf(cType.toLowerCase().split('-').join('')) !== -1)
                        )
                            total++;
                    });
                }

            })

           // console.log(model + ' ' + total);
            return total;
        },
    },
    computed: {
        getCategory: function () {
            var arr = []
            this.json.forEach((carrito) => {
                if (!arr.includes(carrito.type)) {
                    arr.push(carrito.type)
                }
            })
            this.seleCategory = arr[0] || null
            return arr
        },
        sizeCategories: function () {
            var size = this.getCategory.length
            return size > 6 ? 'w-1/4' : 'w-1/' + size;
        },
    },
}